import { schema } from 'normalizr';

const orderStatusSchema = new schema.Entity('orderStatuses');

export default orderStatusSchema;
